var exports = {
  "container": "x9997bc76--a49552--container",
  "container-bottom": "x9997bc76--a49552--container-bottom",
  "wrapper": "x9997bc76--a49552--wrapper",
  "wrapper-bottom": "x9997bc76--a49552--wrapper-bottom",
  "content": "x9997bc76--a49552--content",
  "content-bottom": "x9997bc76--a49552--content-bottom",
  "title": "x9997bc76--a49552--title",
  "qr": "x9997bc76--a49552--qr",
  "apps": "x9997bc76--a49552--apps",
  "button": "x9997bc76--a49552--button",
  "apple-btn": "x9997bc76--a49552--apple-btn",
  "google-btn": "x9997bc76--a49552--google-btn",
  "ru-store-btn": "x9997bc76--a49552--ru-store-btn",
  "huawei-btn": "x9997bc76--a49552--huawei-btn",
  "phone": "x9997bc76--a49552--phone",
  "phone-bottom": "x9997bc76--a49552--phone-bottom",
};

module.exports = exports;
